import { useContext } from 'react';
import { I18nContext, resolveMessage } from './utils';
import type { I18nContextValue } from './types';

export function useTranslate(): I18nContextValue {
  const ctx = useContext(I18nContext) as I18nContextValue | null;
  if (!ctx) {
    return {
      locale: 'en',
      setLocale: () => {},
      t: (key) => resolveMessage('en', key),
    };
  }
  return ctx;
}
